<script>

	import { onMount } from 'svelte';

	import TextField from './fields/TextField.svelte';
	import SelectList from './fields/SelectList.svelte';
	import CheckboxGroup from './fields/CheckboxGroup.svelte';
	import RadioButtons from './fields/RadioButtons.svelte';

	let componentLookup = {
		TextField: 					TextField,
		EmailField: 				TextField,
		UrlField: 					TextField,
		SelectList: 				SelectList,
		Country: 					SelectList,
		CheckboxGroup:				CheckboxGroup,
		RadioButtons: 				RadioButtons,
		PhoneField:					TextField,
		NumberField:				TextField,
		SocialMediaUrlField:		TextField
	};

	export let field;
	export let responses;
	export let problems;

	onMount(() => {
		if (!responses[field.ref] && field.default) {
			responses[field.ref] = field.default;
		}
	});

</script>

<style>

	.field :global(.checkboxes p),
	.field :global(.radiobuttons p) {
		text-align: left;
		margin: 0.25rem 0 0 0;
		padding-left: 1.6em;
		position: relative;
	}

	.field :global(.checkboxes p label),
	.field :global(.radiobuttons p label) {
		font-size: 0.875rem;
	}

	.field :global(.checkboxes .checkbox),
	.field :global(.radiobuttons .radiobutton) {
		width: 1em;
		height: 1em;
		position: absolute;
		top: 0;
		left: 0;
		overflow: visible;
	}

	.field :global(.checkbox input),
	.field :global(.radiobutton input) {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		padding: 0;
		margin: 0;
		opacity: 0;
		z-index: 2;
	}

	.field :global(.checkbox svg),
	.field :global(.radiobutton svg) {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		opacity: 1;
		z-index: 1;
	}

	.field :global(.checkbox path),
	.field :global(.radiobutton path),
	.field :global(.radiobutton circle) {
		fill: currentColor;
		transition: opacity 0.2s ease-in-out;
	}

	.field :global(.checkbox .on path),
	.field :global(.radiobutton .on path),
	.field :global(.radiobutton .on circle) {
		fill: var(--linkColor);
	}

	.field :global(.checkbox path.on-tick),
	.field :global(.radiobutton circle.on-bg) {
		fill: var(--bgColor);
	}

	.field :global(.checkbox input + svg .on),
	.field :global(.radiobutton input + svg .on) {
		opacity: 0;
	}

	.field :global(.checkbox input:checked + svg .on),
	.field :global(.radiobutton input:checked + svg .on) {
		opacity: 1;
	}

	.field :global(.checkbox input:checked + svg path.off) {
		fill: var(--linkColor);	
	}

	.field :global(.Select .options) {
		position: absolute;
		left: 50%;
		top: calc(100% + 4px);
		width: calc(100% - 10px);
		min-width: 100px;
		transform: translateX(-50%);
		background: var(--bgColor);
		box-shadow: 0 1px 6px -1px rgba(0,0,0,0.3);
		z-index: 99999;
		max-height: 200px;
		overflow-y: scroll;
		border-radius: 4px;
	}

	.field :global(.Select .options.low) {
		top: auto;
		bottom: calc(100% + 4px);
	}

	.field :global(.Select .options ul) {
		margin: 0;
		padding: 0;
	}

	.field :global(.Select .options li) {
		list-style: none;
		margin: 0;
		padding: 0.6em 0.8em;
		text-align: left;
		font-size: 14px;
		min-height: 1em;
		user-select: none;
		cursor: pointer;
		color: var(--textColor);
	}

	.field :global(.Select .options li.highlighted) {
		background: var(--highlightColor);
	}

</style>

<div class="field {field.component}" class:problem={problems[field.ref]} class:f={field.ref == "f"} class:l={field.ref == "l"}>
	<label for="azn_s_i_{field.ref}" class="fieldlabel" class:hasContent={(responses[field.ref] != undefined) && (responses[field.ref] != '')}>
		{field.label.EN}
	</label>
	<svelte:component
		this={componentLookup[field.component]}
		bind:field={field}
		bind:response={responses[field.ref]}
		on:focus={() => { problems[field.ref] = false }}
	/>
	{#if problems[field.ref]}
		<svg viewBox="0 0 56 56"><path d="M56 28c0 15.464-12.536 28-28 28s-28-12.536-28-28 12.536-28 28-28 28 12.536 28 28zm-28 19.89c2.455 0 4.583-2.053 4.603-4.604-.02-2.513-2.148-4.564-4.603-4.564-2.532 0-4.623 2.052-4.604 4.564-.02 2.551 2.071 4.604 4.604 4.604zm4.257-39.78h-8.535l.768 26.505h7.019l.748-26.505z"/></svg>
	{/if}
</div>